module.exports = __webpack_public_path__ + "img/og_webtoon.17d10f2a.webp";